<div class="container-blue">
  <div id="accueil"
    class="container">
    <div class="row">
      <div class="col-12">

        <app-mes-informations *ngIf="estAuthentifie && !this.utilisateur.estInscrit"></app-mes-informations>
        <app-bienvenue-sans-acces
          *ngIf="estAuthentifie && utilisateur.estInscrit && estAvecRoleParDefaut"></app-bienvenue-sans-acces>

        <div *ngIf="!estAuthentifie"
          class="container">
          <div class="row">
            <div class="col-sm">
              <h1                 *ngIf="!estAuthentifie"
                [innerHTML]="'accueil.inscription.titre' | translate"></h1>
              <div #descPublic class="text paragraphe divParagraphe"
                id="texte_intro"
                [innerHTML]="'accueil.texte_intro' | translate"></div>
            </div>

            <div class="col-sm boxConnexion"><app-accueil-non-authentifie></app-accueil-non-authentifie></div>
          </div>
        </div>

        <div *ngIf="estAuthentifie && utilisateur.estInscrit && !estAvecRoleParDefaut">
          <h1             [innerHTML]="'accueil.avecAcces.titre' | translate"></h1>
          <p [innerHTML]="'accueil.avecAcces.avis.description' | translate"></p>
          <br /><br />
          <div>
            <a class="lien" routerLink="/carte"
              >{{ 'accueil.lienAccederALaCarte' | translate }}</a>
            <p class="paragraphe">{{ 'accueil.lienAccederALaCarteDescription' | translate }}</p>
          </div>
          <br />
          <div>
            <a class="lien" routerLink="/utilisateur/mes-informations"
              >{{ 'accueil.lienAccederALaModification' | translate }}</a>
            <p class="paragraphe">{{ 'gestionUtilisateur.texteModifier' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<zzz-piv-piedpage></zzz-piv-piedpage>